//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"BlendMiter",1,0],[1,"ClosedCornerGap",0,"Expression",0],[0,"ClosedCornerType",1,0],[1,"ClosedCornerVAngle1",0,"Expression",0],[1,"ClosedCornerVAngle2",0,"Expression",0],[1,"CornerTreatmentOffset",0,"Expression",0],[0,"CornerTreatmentOriginType",1,0],[0,"EndType",1,0],[0,"MiterCorner",1,0],[0,"MiterInteriorCornersIfNecessary",1,0],[1,"MiterRootRadius",0,"Expression",0],[0,"Position",1,0],[0,"StartType",1,0],[1,"ThreeBendCornerFlangeClearance",0,"Expression",0],[0,"UseNormalCutoutMethod",1,0]],[[[],"GetStartValue",{R_:{start_value:"Expression"}},0,0],[[],"GetEndValue",{R_:{end_value:"Expression"}},0,0],[[],"GetClosedCornerDiameter",{R_:{end_value:"Expression"}},0,0],[["end_value"],"SetClosedCornerDiameter",{},1,0]],[]];
SPLM.Features.SheetMetal.MiterOptions = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.MiterOptions";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.MiterOptions.PositionOptions = Object.freeze({
    "None" : "None", "Start" : "Start", "End" : "End", "Both" : "Both"});

SPLM.Features.SheetMetal.MiterOptions.TypeOptions = Object.freeze({
    "NormalToSourceFace" : "NormalToSourceFace", "NormalToThicknessFace" : "NormalToThicknessFace"});

SPLM.Features.SheetMetal.MiterOptions.ClosedCornerTypeOptions = Object.freeze({
    "None" : "None", "Open" : "Open", "Closed" : "Closed", "CircularCutout" : "CircularCutout", "UCutout" : "UCutout", "VCutout" : "VCutout"});

SPLM.Features.SheetMetal.MiterOptions.CornerTreatmentOriginTypeOptions = Object.freeze({
    "BendCenter" : "BendCenter", "CornerPoint" : "CornerPoint"});

export default SPLM;